import { LitElement, html, css } from 'lit'
import { StoreMixin } from '../store.js'

class AppRoot extends StoreMixin(LitElement) {
  static styles = css`
    :host { display: block; min-height: 100vh; }
    /* Content column from the design: 1160px max, 40px page gutters. The trailing
       space is kept slim so a page can dock a footer flush to the bottom of the
       viewport (see page-day's .toolbar). */
    main { max-width: var(--page-max); margin: 0 auto;
           padding: 36px var(--page-gutter) var(--page-pad-bottom); }
    @media (max-width: 640px) { main { padding-top: 24px; } }
  `

  render() {
    const { user } = this.appState
    return html`
      ${user ? html`<app-nav></app-nav>` : ''}
      <main><app-router></app-router></main>
      <app-toast></app-toast>
    `
  }
}

customElements.define('app-root', AppRoot)
